import "../../styles/alerts/alert.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const CompanyAd = ({ closeAd }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);

  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          flexDirection: "column",
          alignItems: "center",
        }}
        className='sync-overlay-backdrop'
        onClick={closeAd}
      >
        {isSmallScreen ? (
          <div className='company-ad-modal small-screen'>
            <img
              onClick={() => {
                navigate("/settings/referral");
              }}
              src='https://res.cloudinary.com/ebuka1122/image/upload/v1766018184/static%20images%20storelens/adpotraite_zjrzwn.webp'
              alt='Company Ad'
            />
          </div>
        ) : (
          <div className='company-ad-modal'>
            <img
              onClick={() => {
                navigate("/settings/referral");
              }}
              src={"https://res.cloudinary.com/ebuka1122/image/upload/v1766017964/static%20images%20storelens/Adlandscape_cvxnhf.webp"}
              alt='Company Ad'
            />
          </div>
        )}

        <button className='closeAdbtn'>X Close </button>
        <button
          onClick={() => {
            navigate("/settings/referral");
          }}
          className=''
        >
          View Details
        </button>
      </div>
    </>
  );
};

export default CompanyAd;
